import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { CompetitionLevelEffects } from './competition-level.effects'
import * as fromCompetitionLevel from './competition-level.reducer'
import { CompetitionLevelSerializer } from './competition-level.serializer'
import { CompetitionLevelService } from './competition-level.service'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromCompetitionLevel.FEATURE_NAME,
      fromCompetitionLevel.competitionLevelReducer
    ),
    EffectsModule.forFeature([CompetitionLevelEffects])
  ],
  providers: [
    CompetitionLevelService,
    {
      provide: CompetitionLevelSerializer,
      useClass: CompetitionLevelSerializer
    }
  ],
  declarations: []
})
export class CompetitionLevelModule {}
